
import { z } from "zod";

export const WorkSiteRoleValues = ["EXTERNAL_CONTRACTOR", "FAMILY_MEMBER", "INSURANCE_AGENT", "OTHER", "PRIMARY", "PROPERTY_MANAGER", "RESIDENT", "SPOUSE", "TENANT"] as const;
export const WorkSiteRoleSchema = /* @__PURE__ */ z.enum(WorkSiteRoleValues);
export const WorkSiteRole: (typeof WorkSiteRoleSchema)["enum"] = { "EXTERNAL_CONTRACTOR": "EXTERNAL_CONTRACTOR", "FAMILY_MEMBER": "FAMILY_MEMBER", "INSURANCE_AGENT": "INSURANCE_AGENT", "OTHER": "OTHER", "PRIMARY": "PRIMARY", "PROPERTY_MANAGER": "PROPERTY_MANAGER", "RESIDENT": "RESIDENT", "SPOUSE": "SPOUSE", "TENANT": "TENANT" };
export type WorkSiteRole = (typeof WorkSiteRoleValues)[number];
export const WorkSiteRoleDisplayNames = { "EXTERNAL_CONTRACTOR": "EXTERNAL_CONTRACTOR",
"FAMILY_MEMBER": "FAMILY_MEMBER",
"INSURANCE_AGENT": "INSURANCE_AGENT",
"OTHER": "OTHER",
"PRIMARY": "PRIMARY",
"PROPERTY_MANAGER": "PROPERTY_MANAGER",
"RESIDENT": "RESIDENT",
"SPOUSE": "SPOUSE",
"TENANT": "TENANT", } satisfies Record<WorkSiteRole, string>;
